module.exports = __webpack_public_path__ + "static/media/cleansing_light.c321decd.png";